import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    height: '100%',
    maxHeight: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    border: `1px solid ${theme.palette.custom.secondary3}`,
    borderRadius: '6px',
    overflow: 'hidden',
    backgroundColor: 'white',
  },
  toolbar: {
    padding: theme.spacing(0.75),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.custom.secondary3}`,
    backgroundColor: 'white',
  },
  toolbarPrimaryButton: {
    textTransform: 'none',
    fontWeight: 600,
    minHeight: 38,
    borderRadius: '5px',
    backgroundColor: theme.palette.custom.primary1,
    border: `1px solid ${theme.palette.custom.primary1}`,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.custom.primary2,
      border: `1px solid ${theme.palette.custom.primary2}`,
    },
  },
  toolbarIconButton: {
    width: 38,
    height: 38,
    borderRadius: '5px',
    backgroundColor: theme.palette.custom.primary1,
    border: `1px solid ${theme.palette.custom.primary1}`,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.custom.primary2,
      border: `1px solid ${theme.palette.custom.primary2}`,
    },
  },
  searchField: {
    width: 180,
    minWidth: 180,
    maxWidth: 180,
    '& .MuiInputBase-root': {
      height: 38,
      backgroundColor: 'white',
      color: theme.palette.custom.secondary1,
      borderRadius: '5px',
      border: `1px solid ${theme.palette.custom.secondary3}`,
      paddingRight: theme.spacing(1),
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.custom.secondary2,
      opacity: 1,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.custom.secondary2,
    },
  },
  settingsButton: {
    width: 38,
    height: 38,
    borderRadius: '5px',
    border: `1px solid ${theme.palette.custom.secondary3}`,
    color: theme.palette.custom.secondary2,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: theme.palette.custom.secondary4,
    },
  },
  activeToolbarButton: {
    backgroundColor: theme.palette.custom.primary1,
    border: `1px solid ${theme.palette.custom.primary1}`,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.custom.primary2,
      border: `1px solid ${theme.palette.custom.primary2}`,
    },
  },
  filtersBadge: {
    '& .MuiBadge-badge': {
      top: 4,
      right: 4,
    },
  },
  columnsMenuHeader: {
    fontSize: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: theme.palette.custom.secondary2,
    padding: theme.spacing(1, 2, 0.5, 2),
  },
  columnsMenuItem: {
    minWidth: 260,
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  columnsMenuLabel: {
    flex: 1,
    fontSize: '0.92rem',
  },
  toolbarActions: {
    marginLeft: 'auto',
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  actionButton: {
    textTransform: 'none',
    minHeight: 38,
    borderRadius: '5px',
    fontWeight: 600,
    border: `1px solid ${theme.palette.custom.primary1}`,
    color: 'white',
    backgroundColor: theme.palette.custom.primary1,
    '&:hover': {
      backgroundColor: theme.palette.custom.primary2,
      border: `1px solid ${theme.palette.custom.primary2}`,
    },
    '&:disabled': {
      backgroundColor: 'white',
      border: `1px solid ${theme.palette.custom.secondary3}`,
      color: theme.palette.custom.secondary2,
    },
  },
  filtersModalPaper: {
    borderRadius: 8,
  },
  filtersModalTitle: {
    borderBottom: `1px solid ${theme.palette.custom.secondary3}`,
    padding: theme.spacing(1.5, 2),
  },
  filtersModalContent: {
    padding: theme.spacing(2),
  },
  filtersModalActions: {
    borderTop: `1px solid ${theme.palette.custom.secondary3}`,
    padding: theme.spacing(1.5, 2),
  },
  filtersContainer: {
    padding: theme.spacing(0.5, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    backgroundColor: 'white',
  },
  dateFiltersSection: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    alignItems: 'flex-start',
    padding: theme.spacing(1.25),
    borderRadius: 6,
    backgroundColor: theme.palette.custom?.secondary5 || 'rgba(0, 0, 0, 0.02)',
    border: `1px solid ${theme.palette.custom.secondary4}`,
  },
  dateFiltersSectionLabel: {
    width: '100%',
    fontSize: '0.7rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.custom.secondary2,
    marginBottom: theme.spacing(0.25),
  },
  filterTypeSectionsGrid: {
    display: 'grid',
    gap: theme.spacing(1.5),
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  },
  filterSectionBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'stretch',
    padding: theme.spacing(1.25),
    borderRadius: 6,
    backgroundColor: theme.palette.custom?.secondary5 || 'rgba(0, 0, 0, 0.02)',
    border: `1px solid ${theme.palette.custom.secondary4}`,
  },
  filterSectionLabel: {
    width: '100%',
    fontSize: '0.7rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.custom.secondary2,
    marginBottom: theme.spacing(0.25),
  },
  filterSectionFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  rangeFilter: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(0.5),
  },
  filterLabel: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.custom.secondary2,
    fontWeight: 600,
  },
  dateRangeFilter: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 200,
  },
  rangeSliderFilter: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 200,
  },
  rangeSlider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  rangeFilterInputs: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(0.5),
  },
  filterFormControl: {
    minWidth: 180,
  },
  chipBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.25),
  },
  filterChip: {
    height: 24,
  },
  tableContainer: {
    flex: '1 1 auto',
    height: 0,
    minHeight: 0,
    overflow: 'auto',
    position: 'relative',
  },
  loadingOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3,
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
    backdropFilter: 'blur(1.5px)',
  },
  tableBodyLoading: {
    filter: 'blur(1.5px)',
    pointerEvents: 'none',
  },
  headerCell: {
    backgroundColor: 'white',
    borderBottom: `1px solid ${theme.palette.custom.secondary3}`,
    fontWeight: 600,
    fontSize: '0.98rem',
    whiteSpace: 'nowrap',
  },
  bodyCell: {
    borderBottom: `1px solid ${theme.palette.custom.secondary4}`,
    fontSize: '0.88rem',
    color: theme.palette.custom.secondary1,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 320,
  },
  clickableRow: {
    cursor: 'pointer',
    '&.Mui-selected': {
      backgroundColor: '#eaf3ff',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#deecff',
    },
  },
  selectedRow: {
    backgroundColor: '#eaf3ff',
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(3),
    color: theme.palette.custom.secondary2,
  },
  sumRow: {
    backgroundColor: theme.palette.custom.secondary4,
    borderTop: `2px solid ${theme.palette.custom.secondary3}`,
  },
  sumCell: {
    borderBottom: `1px solid ${theme.palette.custom.secondary3}`,
    fontSize: '0.8rem',
    padding: theme.spacing(0.75, 1),
    verticalAlign: 'middle',
  },
  sumCellContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  sumScopeSelect: {
    minWidth: 120,
    fontSize: '0.75rem',
    '& .MuiSelect-select': {
      padding: theme.spacing(0.5, 1),
    },
  },
  sumValue: {
    fontWeight: 600,
    color: theme.palette.custom.secondary1,
  },
  pagination: {
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.custom.secondary3}`,
  },
}));
